import Box from "../Box";
import type { Stat } from "../RowStats";
import { StatItem } from "../StatItem";
type Props = {
	stats: Stat[];
};

const PostAnswerStats = (props: Props) => {
	const { stats } = props;

	return (
		<Box flexDirection="row" alignItems="center" justifyContent="space-around">
			{stats.map(({ icon, label, value, color, tooltip }) => (
				<Box key={label} flexDirection="row" flex={1} justifyContent="center">
					<StatItem
						icon={icon}
						value={`${value}`}
						overlineText={label}
						color={color}
						stacked
						tooltip={tooltip}
					/>
				</Box>
			))}
		</Box>
	);
};

export default PostAnswerStats;
